module.exports = __webpack_public_path__ + "img/HH2019plakatb.72ac9a7a.jpg";